import React from 'react';
import PropTypes from 'prop-types';

import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import MenuItem from 'material-ui/MenuItem';

import info from '../constants/infotexts.json';
import choices from '../constants/choices.json';

const { Strategy } = choices;

const styles = {
    flex: {
        flex: 1,
        marginBottom: '2em',
    },
};

class StrategyTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.Strategy1 !== next.Strategy1
        || old.Strategy2 !== next.Strategy2
        || old.Strategy3 !== next.Strategy3
        || old.Strategy4 !== next.Strategy4
        || old.Strategy5 !== next.Strategy5;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    render() {
        const { data } = this.props;
        return (
            <section style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <InfoSelectField
                    floatingLabelText="Forskning/kunstnerisk virksomhet"
                    infoText={info.strategy.Strategy1}
                    value={data.Strategy1}
                    onChange={this.handleSelectChange('Strategy1')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Strategy.Strategy1.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Strategy1 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Utdanning og læringsmiljø"
                    infoText={info.strategy.Strategy2}
                    value={data.Strategy2}
                    onChange={this.handleSelectChange('Strategy2')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Strategy.Strategy2.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Strategy2 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Innovasjon og nyskapning"
                    infoText={info.strategy.Strategy3}
                    value={data.Strategy3}
                    onChange={this.handleSelectChange('Strategy3')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Strategy.Strategy3.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Strategy3 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Formidling og kommunikasjon"
                    infoText={info.strategy.Strategy4}
                    value={data.Strategy4}
                    onChange={this.handleSelectChange('Strategy4')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Strategy.Strategy4.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Strategy4 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Ledelse, medvirkning og ressurser"
                    infoText={info.strategy.Strategy5}
                    value={data.Strategy5}
                    onChange={this.handleSelectChange('Strategy5')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Strategy.Strategy5.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Strategy5 === item.key}
                        />
                    ))}
                </InfoSelectField>
            </section>
        );
    }
}

StrategyTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default StrategyTab;



// WEBPACK FOOTER //
// ./src/components/StrategyTab.js